'use strict';

const Analytics = require('./analytics');

function isCart () {
    return window.location.href.toLowerCase().indexOf('cart') !== -1;
}

class AnalyticsMinicart extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'AnalyticsMinicart';
        super.init(globalContainer, helperContainer);

        this.prepareObservers();
    }

    prepareMinicartObservers () {
        let _self = this;

        // Go to bag link
        $('body').on('click', '#checkout-button-goto-cart', function (e) {
            _self.quickImpressionSender.pushMinicartCheckoutClickInteraction();
        });

        // Paypal button in mini cart
        $('body').on('analytics:paypal', function (e) {
            if (!isCart()) {
                _self.quickImpressionSender.pushMinicartCheckoutClickInteraction();
            }
        });

        // Proceed button
        $('body').on('click', '.minicart-checkout-button', function (e) {
            _self.quickImpressionSender.pushMinicartCheckoutClickInteraction();
        });

        $('body').on('click', '.cc-minicart_checkoutButtons_orderTotal .checkout-btn', function (e) {
            _self.quickImpressionSender.pushBeginCheckout(_self.helper.getBeginCheckoutData(_self));
        });

        $('body').on('click', '.analytics-minicart-actions', function (e) {
            _self.quickImpressionSender.pushMinicartInteraction($(e.currentTarget).data('analytics-action'));
        });

        $('body').on('click', '.analytics-mini-cart #complete-your-promo', function (e) {
            let name = _self.helper.formatString($(e.currentTarget).data('promotion-id'));
            _self.quickImpressionSender.pushCompleteThePromoInteraction(name, 'minicart');
        });
    }

    prepareObservers () {
        var _self = this;

        $('body').on('minicart:open', function (e) {
            _self.log('Minicart Open', true);
            _self.prepareMinicartObservers();
        });

        $('body').on('minicart:close', function (e) {
            _self.log('Minicart Close', true);
        });
    }
}

const obj = new AnalyticsMinicart();
module.exports = obj;
